import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { loginClient } from '../../../../../../../crud/clients_api/clients';
import './ClientLogin.scss';

interface ClientLoginProps {
  destination: string | undefined;
  navigate: any;
}

const ClientLogin: React.FC<ClientLoginProps> = ({ destination, navigate }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordShown(!isPasswordShown);
  };

  const handleManualLogin = async () => {
    if (!username || !password) {
      setError('Por favor completa todos los campos');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await loginClient(username, password, null, null);
      if ((response as any).status === 200) {
        localStorage.setItem('access_token', JSON.stringify((response as any).data.token));
        localStorage.setItem('client', JSON.stringify((response as any).data));
        navigate(`/${destination || 'ClientPortal/Home'}`);
      } else {
        setError('Error al iniciar sesión');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Error al iniciar sesión. Verifica tus credenciales.');
      console.error("ERROR ->", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleManualLogin();
    }
  };

  return (
    <div className="client-login-form">
      <div className="form-field">
        <label htmlFor="username">Usuario o Email</label>
        <input
          type="text"
          id="username"
          value={username}
          placeholder="Ingresa tu usuario o email"
          onChange={(e) => setUsername(e.target.value)}
          onKeyPress={handleKeyPress}
          disabled={isLoading}
          autoComplete="username"
        />
      </div>

      <div className="form-field">
        <label htmlFor="password">Contraseña</label>
        <div className="password-input-wrapper">
          <input
            type={isPasswordShown ? "text" : "password"}
            id="password"
            value={password}
            placeholder="Ingresa tu contraseña"
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isLoading}
            autoComplete="current-password"
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="password-toggle-btn"
            disabled={isLoading}
            aria-label="Mostrar/Ocultar contraseña"
          >
            <FontAwesomeIcon icon={isPasswordShown ? faEyeSlash : faEye} />
          </button>
        </div>
      </div>

      <div className="forgot-password-link">
        <a href="/ruta-para-recuperar-contrasena">¿Olvidaste tu contraseña?</a>
      </div>

      {error && <p className="form-error-message">{error}</p>}

      <Button
        className="login-submit-btn"
        onClick={handleManualLogin}
        disabled={isLoading}
      >
        {isLoading ? 'Ingresando...' : 'Ingresar'}
      </Button>
    </div>
  );
};

export default ClientLogin;